import { getParameterByName } from "lib/url";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "domain/Game/api";
import PayStatusModals from "./ui/PayStatusModals";
import { useQuery } from "@tanstack/react-query";

const PayStatus = ({ privateCode, history }) => {
    const id = getParameterByName("payId");

    useEffect(() => {
        if (id) {
            let url = new URL(document.location.href);
            url.searchParams.delete("payId");
            history.replace(url.pathname + url.search);
        }
    }, []);

    const { data: gameData } = useQuery({
        queryKey: ["gameData", id, privateCode],
        queryFn: () => get({ id, code: privateCode }),
        enabled: !!id,
    });

    return <>{gameData && <PayStatusModals gameData={gameData} />}</>;
};

PayStatus.propTypes = {
    privateCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    history: PropTypes.object,
};

export default PayStatus;
